import React, {
  useState,
  useRef,
  useEffect,
} from 'react';
import { useQueries } from '@tanstack/react-query';
import { Link } from "react-router";

import * as CONSTANTS from "../constants";
import * as QUERIES from "../query-functions";

import InstanceEventSummary from '../components/instance-event-summary';
import InstanceBasketSummary from '../components/instance-basket-summary';
import ExtrasInstance from './extras-instance';
import BackButton from '../components/back-button';
import LoadingIndicator from '../components/loading-indicator';

export default function Extras(props) {
    const [groupedInstances, setGroupedInstances] = useState(null);

    const query_ids = CONSTANTS.SUPPLEMENTARY_INSTANCES;
    const query_map = query_ids?.map((instance_id) => ({
            queryKey: ['instance', instance_id],
            queryFn: () => QUERIES.getInstance(instance_id), 
            refetchOnWindowFocus: false
    }));

    const combinedExtras = useQueries({
        queries: query_map,
        combine: (results) => {
            return {
                data: results.map((result) => result.data),
                pending: results.some((result) => result.isPending),
            }
        },
    });

    useEffect(() => {
        // Extras need to be split in to groups according to the ExtrasScreenSection attribute set in Spektrix
        if (!combinedExtras || !combinedExtras.data || combinedExtras.pending) return;
        let primary_instances = [];
        let secondary_instances = [];

        combinedExtras.data.map((instance) => {
            if (instance.attribute_ExtrasScreenSection && 
                    instance.attribute_ExtrasScreenSection == "Primary") {
                primary_instances.push(instance);
            } else {
                secondary_instances.push(instance);
            }
        });

        setGroupedInstances(
            [
                {
                    title: "Don't forget",
                    instances: primary_instances
                },
                {
                    title: "Enhance your experience",
                    instances: secondary_instances
                }
            ]
        )

    }, [combinedExtras]);

    return (
        <div className='booking-pathway__container booking-pathway__extras'>
            <InstanceEventSummary />
            
            <div className='booking-pathway__main-content'>
                {!combinedExtras.pending && groupedInstances ? (
                    groupedInstances.map((group) =>
                        group.instances.length ? (
                            <div key={group.title} className='extras-group'>
                                <h2 className='extras-group__title'>{group.title}</h2>

                                {group.instances.map((instance) => (
                                    <ExtrasInstance key={instance.id} instance={instance} />
                                ))}

                            </div>
                        ) : null
                    )
                ) : 
                    <LoadingIndicator />
                }
            </div>

            <InstanceBasketSummary />

            <div className='booking-pathway__footer'>
                <Link to="/basket" className='btn btn--primary'>Continue</Link>
                <BackButton />             
            </div>
        </div>
    );
}